import React from 'react';
import { TITLE, ink } from '../../primitives.js';

const h = React.createElement;

const SHAPES = { quarter: { borderRadius: '100% 0 0 0', background: 'var(--lime)' }, dot: { borderRadius: '50%', background: 'var(--gold)' }, square: { background: 'var(--coral)' }, half: { borderRadius: '100% 100% 0 0', background: 'var(--gold)' } };

/**
 * Dashed-border empty state with one shape bleeding off the corner. `idle` starts the 12s
 * rotation.
 *
 * @param {object} p
 * @param {React.ReactNode} p.title
 * @param {React.ReactNode} [p.body]
 * @param {'quarter'|'dot'|'square'|'half'} [p.shape]
 * @param {React.ReactNode} [p.action]
 * @param {boolean} [p.idle]
 * @param {React.CSSProperties} [p.style]
 */
export function EmptyState({ title, body, shape = 'quarter', action, idle, style }) {
  return h('div', { className: 'gx-empty', style: { position: 'relative', overflow: 'hidden', border: '2px dashed var(--ink)', borderRadius: 12, padding: '18px 20px', minHeight: 84, boxSizing: 'border-box', ...style } },
    h('div', { style: { fontFamily: TITLE, fontWeight: 800, fontSize: 17, letterSpacing: '-.01em', lineHeight: 1.15, marginBottom: 4, maxWidth: '75%' } }, title),
    body ? h('div', { style: { fontSize: 13, lineHeight: 1.5, color: 'var(--tx2)', maxWidth: '70%', textWrap: 'pretty' } }, body) : null,
    action ? h('div', { style: { marginTop: 12 } }, action) : null,
    h('div', { 'aria-hidden': true, className: 'gx-peek' + (idle ? ' mo-idle' : ''), style: { position: 'absolute', right: -28, bottom: -28, width: 86, height: 86, border: ink(2), boxSizing: 'border-box', transformOrigin: '100% 100%', ...SHAPES[shape] } }));
}
